import { Link } from "@tanstack/react-router";
import {
  Edit,
  MainMenuCommiter as Users,
  MainMenuExtend,
  MainMenuReduced,
  MainMenuReport,
  Maintenance,
  Report,
} from "@totalenergiescode/mobility-business-rev-design-system";
import { useTranslation } from "react-i18next";

import { Home } from "@/components/Icons/generated";
import { Loading } from "@/components/shared/Loading";
import { useAbilities } from "@/hooks/ability/hooks";
import { useUiStore } from "@/stores/ui";

import {
  Drawer,
  StyledBox,
  StyledList,
  StyledListItem,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
} from "./styles";

const iconSize = 48;

export const SideBar = () => {
  const open = useUiStore(({ uiState }) => uiState.isSidebarOpen);
  const toggleSidebarOpen = useUiStore(
    ({ toggleSidebarOpen }) => toggleSidebarOpen,
  );
  const { t: tSidebar } = useTranslation("common");
  const { can, isLoading } = useAbilities();

  return (
    <StyledBox>
      <Loading isLoading={isLoading}>
        <Drawer variant='permanent' open={open}>
          <StyledList>
            <StyledListItem>
              <Link to='/' className='[&.active]:font-bold'>
                <StyledListItemButton open={open}>
                  <StyledListItemIcon open={open}>
                    <Home width={iconSize} height={iconSize} color='white' />
                  </StyledListItemIcon>
                  <StyledListItemText
                    primary={tSidebar("common.sidebar.home")}
                    open={open}
                  />
                </StyledListItemButton>
              </Link>
            </StyledListItem>
            {can("SUPER_AGENT") && (
              <StyledListItem>
                <Link to='/backoffice-users' className='[&.active]:font-bold'>
                  <StyledListItemButton open={open}>
                    <StyledListItemIcon open={open}>
                      <Users width={iconSize} height={iconSize} color='white' />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={tSidebar("common.sidebar.users")}
                      open={open}
                    />
                  </StyledListItemButton>
                </Link>
              </StyledListItem>
            )}
            {can("MAINTAINER") && (
              <StyledListItem>
                <Link to='/migration-report' className='[&.active]:font-bold'>
                  <StyledListItemButton open={open}>
                    <StyledListItemIcon open={open}>
                      <Report
                        width={iconSize}
                        height={iconSize}
                        color='white'
                      />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={tSidebar("common.sidebar.migrationReport")}
                      open={open}
                    />
                  </StyledListItemButton>
                </Link>
              </StyledListItem>
            )}
            {can("MAINTAINER") && (
              <StyledListItem>
                <Link to='/migration-status' className='[&.active]:font-bold'>
                  <StyledListItemButton open={open}>
                    <StyledListItemIcon open={open}>
                      <MainMenuReport
                        width={iconSize}
                        height={iconSize}
                        color='white'
                      />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={tSidebar("common.sidebar.migrationStatus")}
                      open={open}
                    />
                  </StyledListItemButton>
                </Link>
              </StyledListItem>
            )}
            {can("MAINTAINER") && (
              <StyledListItem>
                <Link to='/formdata-injector' className='[&.active]:font-bold'>
                  <StyledListItemButton open={open}>
                    <StyledListItemIcon open={open}>
                      <Edit width={iconSize} height={iconSize} color='white' />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={tSidebar("common.sidebar.formDataInjector")}
                      open={open}
                    />
                  </StyledListItemButton>
                </Link>
              </StyledListItem>
            )}
            {can("MAINTAINER") && (
              <StyledListItem>
                <Link to='/form-engine' className='[&.active]:font-bold'>
                  <StyledListItemButton open={open}>
                    <StyledListItemIcon open={open}>
                      <Maintenance
                        width={iconSize}
                        height={iconSize}
                        color='white'
                      />
                    </StyledListItemIcon>
                    <StyledListItemText
                      primary={tSidebar("common.sidebar.formEngine")}
                      open={open}
                    />
                  </StyledListItemButton>
                </Link>
              </StyledListItem>
            )}
            <StyledListItem
              style={{ marginBlockStart: "auto" }}
              onClick={toggleSidebarOpen}
            >
              <StyledListItemButton open={open}>
                <StyledListItemIcon open={open}>
                  {open ? (
                    <MainMenuReduced
                      width={iconSize}
                      height={iconSize}
                      color='white'
                    />
                  ) : (
                    <MainMenuExtend
                      width={iconSize}
                      height={iconSize}
                      color='white'
                    />
                  )}
                </StyledListItemIcon>
              </StyledListItemButton>
            </StyledListItem>
          </StyledList>
        </Drawer>
      </Loading>
    </StyledBox>
  );
};
